import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BoardsService} from "@components/boards/boards.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";


@Component({
    selector: 'app-new-board',
    templateUrl: './new-board.component.html',
    styleUrls: ['./new-board.component.css']
})
export class NewBoardComponent implements OnInit {

    modalTitle = 'Unos novog boarda';
    form: FormGroup;

    projectId = '';

    constructor(private dialogRef: MatDialogRef<NewBoardComponent>,
                @Inject(MAT_DIALOG_DATA) public dialogData: any,
                private boardsService: BoardsService,
                private toastr: ToastrService) {
    }

    ngOnInit(): void {

        this.projectId = '';
        this.form = new FormGroup({
            name: new FormControl('', Validators.required),
            hashes: new FormControl([]),
            project: new FormControl(''),
            type: new FormControl('kanban', Validators.required)
        });

    }

    closeModal() {
        this.dialogRef.close(false);
    }

    addNewBoard() {
        if (this.form.invalid) {
            this.toastr.info('Molimo Vas pravilno popunite polja.');
            return;
        }
        if (this.form.get('type').value === 'scrum' && this.projectId == '') {
            this.toastr.info('Scrum board mora imati projekat.');
            return;
        }


        this.boardsService.addBoard(this.form.get('name').value,
            this.form.get('type').value,
            this.projectId,
            this.form.get('hashes').value).subscribe((responseData: BackendResponse) => {
            if (responseData.type == 'success') {
                this.toastr.success('Uspješno kreiran board.');
                this.dialogRef.close(true);
            } else {
                this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.');
            }
        });

    }

    getProjectHandler(event: { _id: string, name: string, type: string }) {
        this.projectId = '';
        if (event._id) {
            this.projectId = event._id;
        }
    }

    getHashesHandler(event) {
    }


}
